import { Chip, Flex, Text } from '@shared/components';

import type { TimePostponementSessionState } from '../../types';
import { formatSessionStartToEndTime } from '../../utils';

interface TimePostponementSessionTimeProps {
  sessions: TimePostponementSessionState[];
}

export default function TimePostponementSessionTime(
  props: Readonly<TimePostponementSessionTimeProps>,
) {
  const { sessions } = props;

  const isMultipleSessions = sessions.length > 1;

  return (
    <Flex
      sx={(theme) => ({
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: theme.shape.rounded(2),
        p: theme.spacing(4),
        gap: theme.spacing(6),
        backgroundColor: theme.palette.grey[50],
      })}
    >
      <Text>เวลาสอบเดิม:</Text>
      <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2) })}>
        {sessions.map((session) => (
          <Flex
            sx={(theme) => ({
              alignItems: 'center',
              gap: theme.spacing(2),
              color: session.isStarted ? theme.palette.grey[400] : 'inherit',
            })}
            key={session.round}
          >
            {isMultipleSessions ? (
              <Text variant='body1Semibold'>ช่วงที่ {session.round}:</Text>
            ) : null}
            <Text variant='body1Semibold'>
              {formatSessionStartToEndTime(session.start, session.end)}
            </Text>
            {session.isStarted ? (
              <Chip
                label='เริ่มสอบแล้ว'
                variant='outlined'
                size='small'
                sx={{
                  fontSize: '12px',
                }}
              />
            ) : null}
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
